module.exports = __webpack_public_path__ + "img/yahoo.e36a5145.svg";